import { ProgressVisualisation } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component(
    "progressVisualisation",
    react2angular(ProgressVisualisation, ["ariaLabel", "count", "duration", "lineWidth", "progressColour", "showPercentage", "size", "strokeColour", "total"])
);
